module.exports = __webpack_public_path__ + "static/media/dude.4087e99b.png";